import { AUTH_INFO_COOKIE } from '../../constants'
import { type Credentials, CredentialsSchema } from '../../entities'
import { deleteCookie, getCookie, setCookie } from '@/tools/cookies'

export const getCredentials = (): Credentials | null => {
  const value = getCookie(AUTH_INFO_COOKIE)
  if (!value) {
    return null
  }
  const payload = JSON.parse(value)
  return CredentialsSchema.parse(payload)
}

export const setCredentials = (credentials: Credentials) => {
  const payload = CredentialsSchema.parse(credentials)
  setCookie(AUTH_INFO_COOKIE, JSON.stringify(payload))
}

export const removeCredentials = () => {
  deleteCookie(AUTH_INFO_COOKIE)
}
